import React from 'react';
import { HtmlField } from 'framework/ui/field';
import { TimelineCollapsible } from 'framework/ui/timeline';
import BasePersonTimelineRecordLayout from 'domain/shared/timeline/person/PersonTimelineRecord/BasePersonTimelineRecordLayout';
import { CREATE_VENDOR_NOTE_PERMISSION, READ_VENDOR_NOTES_PERMISSION } from '../../useVendorNoteService';
import {
  VENDOR_TIMELINE_ICONS,
  VENDOR_TIMELINE_MESSAGE_CONTEXT,
  VENDOR_TIMELINE_RECORD_TYPES,
} from '../../../constants';
import { useVendorId, useVendorsUrl } from 'domain/finance/vendors/routes';
import PersonTimelineRecordHeader from 'domain/shared/timeline/person/PersonTimelineRecord/PersonTimelineRecordHeader';
import { EditTimelineRecordButton } from 'domain/shared/timeline/button';

type NoteTimelineRecordLayoutProps = {
  onEdit: () => void;
  actionName: string;
};

const VendorNoteTimelineRecordLayout = ({ onEdit, actionName, ...props }: NoteTimelineRecordLayoutProps) => {
  const id = useVendorId();
  const { getTimelineUrl } = useVendorsUrl();
  const buttons = [
    <EditTimelineRecordButton permissionToCheck={CREATE_VENDOR_NOTE_PERMISSION} key="edit" onEdit={onEdit} />,
  ];

  return (
    <BasePersonTimelineRecordLayout
      permissionToCheck={READ_VENDOR_NOTES_PERMISSION}
      actionName={actionName}
      timelineType={VENDOR_TIMELINE_RECORD_TYPES.Note}
      timelineIcons={VENDOR_TIMELINE_ICONS}
      messageContext={VENDOR_TIMELINE_MESSAGE_CONTEXT}
      buttons={buttons}
      artifactsSource="attachments"
      noteTextSource="text"
      basePathname={getTimelineUrl(id)}
      isDocumentStorage
      isShowButtons={data => {
        return data.createdBy !== 'system';
      }}
      fields={
        <TimelineCollapsible>
          <HtmlField source="text" label="" />
        </TimelineCollapsible>
      }
      timelineHeader={(rest: any) => <PersonTimelineRecordHeader {...rest} createdBySource="createdBy" />}
      {...props}
    />
  );
};

export default VendorNoteTimelineRecordLayout;
